import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "title", "optionalText", "onClose", "size"];
import React from 'react';
import classNames from 'classnames/bind';
import { CloseLinear } from "../icons";
import { cssUtils } from "../internal/CssUtils";
import { TextBase } from "../internal/TextBase";
import Depth from '../Depth';
import Scrollbar from '../Scrollbar';
import Title from '../Title';
import styles from './HeaderPopup.css';
var cx = classNames.bind(styles);
export var HeaderPopup = function HeaderPopup(_ref) {
  var children = _ref.children,
      title = _ref.title,
      optionalText = _ref.optionalText,
      onClose = _ref.onClose,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cx('root', _defineProperty({}, "size_".concat(size), size))
  }), /*#__PURE__*/React.createElement(Depth, {
    depth: "z300W",
    classes: {
      root: cx('depth')
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, size !== 'small' && /*#__PURE__*/React.createElement("button", {
    className: cx('close_button'),
    type: "button",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseLinear, null), "close Popup"), /*#__PURE__*/React.createElement(Scrollbar, null, /*#__PURE__*/React.createElement("div", {
    className: cx('head', {
      withoutMargin: !title
    })
  }, title ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cssUtils('xs:hidden')
  }, /*#__PURE__*/React.createElement(Title, {
    level: 4,
    as: "span",
    ellipsis: true
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: cssUtils('hidden', 'xs:block')
  }, /*#__PURE__*/React.createElement(Title, {
    level: 3,
    as: "span",
    ellipsis: true
  }, title))) : null, optionalText ? /*#__PURE__*/React.createElement(TextBase, null, optionalText) : null), children))));
};
export default HeaderPopup;